module.exports = __webpack_public_path__ + "img/localfluence-splash.8032cc2b.png";